import React from 'react';

import styles from './SelectionAssistance.module.css'
import {Icon} from "../../ui/General/Icon/Icon.tsx";
import {PUBLIC_PHONE} from "../../utils/formatters/index.ts";

interface Props {
}

export const SelectionAssistance: React.FC<Props> = () => {
    return (
        <div className={styles.selectionAssistance}>
            <div className={styles.selectionAssistanceText}>Помощь в подборе:</div>
            <div className={styles.selectionAssistanceIcons}>
                <a href="javascript:jivo_api.open()">
                    <Icon name='operator' width={26} height={29} className={styles.selectionAssistanceIcon} />
                </a>
                <a href={`tel:${PUBLIC_PHONE}`}>
                    <Icon name='calling' width={25} height={29}
                          className={styles.selectionAssistanceIcon}
                    />
                </a>
                <a className="waconvert" href="https://api.whatsapp.com/send?phone=79841576629">
                <Icon name='whatsapp' width={29} height={29}
                      className={styles.selectionAssistanceIcon}
                />
                </a>
            </div>
        </div>
    );
};